var modules_a4a8ece5 = {"itemWrapper":"DesktopMenuTopLink_module_itemWrapper__a1af676e","item":"DesktopMenuTopLink_module_item__a1af676e"};
import "../../../assets/esm/components/DesktopMenu/src/DesktopMenuTopLink~BlZnYPIv.css";

export { modules_a4a8ece5 as default };
//# sourceMappingURL=DesktopMenuTopLink.module.less.js.map
